module.exports = __webpack_public_path__ + "img/logo.0baed436.png";